import React from 'react';
import { GrFacebookOption } from "react-icons/gr";
import { FaInstagram } from "react-icons/fa";
import { IoLogoTwitter } from "react-icons/io";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { TiSocialPinterest } from "react-icons/ti";
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <>

            {/* <div className="relative custom-padding-top">
                <img
                    src={require('../../src/assets/images/lastbanner.png')}
                    alt="Background Image"
                    className="w-full"
                />
                <div className="custom-padding xl-screen-padding absolute inset-0 flex items-center">
                    <div className="text-left text-[#2B343B] max-w-lg">
                        <h2 className="text-h2 typewriter-effect sm:text-lg md:text-3xl font-bold client-text custom-text-space">
                            We don’t just
                            <span className="block sm:inline"> address the problem</span>
                        </h2>
                        <p className="text-p font-lato hidden sm:block">
                            We uncover its
                            <span className="text-[#8b668d]"> root cause</span>
                            <span className="block sm:inline text-[#8b668d]"> and deliver personalized solutions.</span>
                        </p>
                    </div>
                </div>
            </div> */}
            <footer className="custom-padding xl-screen-padding custom-padding-top custom-container-text-top bg-gray-100">
                <div className="custom-space mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 sm:gap-8 w-full">
                    <div>
                        <h5 className="font-bold text-lg mb-4 font-lato">About Nutrillion</h5>
                        <ul className="text-[#000000] text-lg sm:text-sm font-roboto grid grid-cols-2 sm:grid-cols-1 gap-2">
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">
                            <Link to="/about-us">About Us</Link> 
                            </li>
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">
                            <Link to="/blog">Blogs</Link> 
                            </li>
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">
                            <Link to="/privacy-policy">Privacy Policy</Link> 
                            </li>
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">
                            <Link to="/terms-conditions">Terms & Conditions </Link> 
                            </li>
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">
                            <Link to="/refund-policy">Cancellation & Refund Policy   </Link> 
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h5 className="font-bold text-lg mb-4 font-lato">Services</h5>
                        <ul className="text-[#000000] text-lg sm:text-sm font-roboto grid grid-cols-2 sm:grid-cols-1 gap-2">
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">NutriGenesis                             </li>
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">NutriBioBalance</li>
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">NutriPrelude                            </li>
                        </ul>
                    </div>
                    <div>
                        <h5 className="font-bold text-lg mb-4 font-lato">Quick Links</h5>
                        <ul className="text-[#000000] text-lg sm:text-sm font-roboto grid grid-cols-2 sm:grid-cols-1 gap-2">
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">
                                <Link to="/case-study">Case Study</Link>                            </li>                         
                            <li className="mb-1 inline-block w-fit border-b border-[#000000] sm:border-none">
                            <Link to="/contact">Contact Us</Link> 
                            </li>

                        </ul>
                    </div>
                    <div>
                        <h5 className="font-bold text-lg mb-4 font-lato">Social Links</h5>
                        <ul className="space-y-2 text-gray-600 text-sm font-roboto">
                            <li className="flex space-x-4  pb-3 ">
                                <a href="https://www.facebook.com/people/Nutrillionofficial/61585798517692/" className="text-blue-600 hover:text-blue-800" target="_blank">
                                    <GrFacebookOption className="text-lg" />
                                </a>


                                <a href="https://www.instagram.com/nutrillion.official" className="text-pink-600 hover:text-pink-800" target="_blank">
                                    <FaInstagram className="text-lg" />
                                </a>

                                {/* <a href="#" className="text-blue-400 hover:text-blue-600">
                                    <IoLogoTwitter className="text-lg" />
                                </a> */}
                                <a href="https://www.linkedin.com/company/nutrivison-wellness-and-genetics-private-limited/" className="text-blue-700 hover:text-blue-900" target="_blank">
                                    <FaLinkedinIn className="text-lg" />
                                </a>

                                <a href="#" className="text-red-600 hover:text-red-800">
                                    <FaYoutube className="text-lg" />
                                </a>
                                {/* <a href="#" className="text-blue-700 hover:text-blue-900">
                                    <TiSocialPinterest className="text-lg" />
                                </a> */}
                            </li>
                            <p className="text-[#000000] mb-4 text-lg sm:text-sm font-roboto">Want Daily dose of health?</p>
                        </ul>
                    </div>
                    <div>
                        <h5 className="font-bold text-lg mb-4  font-lato">Download All</h5>
                        <div className="flex flex-row md:flex-col space-y-0 md:space-y-3">
                            <a href="#" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={require('../../src/assets/images/Google play.webp')}
                                    alt="Google Play"
                                    className="w-32 h-auto"
                                />
                            </a>
                            <a href="#" target="_blank" rel="noopener noreferrer">
                                <img
                                    src={require('../../src/assets/images/App Store.webp')}
                                    alt="App Store"
                                    className="w-32 h-auto"
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="custom-space mx-auto grid grid-cols-1 gap-8 text-left md:grid-cols-3 items-center">
                    <div className="flex flex-col items-start md:flex-row md:items-center justify-start space-x-4">
                        <img
                            src={require('../../src/assets/images/Footer_Amity.png')}
                            alt="Amity Innovation Incubator"
                            className="w-full h-auto "
                        />
                        {/* <div className="text-left mt-2 md:mt-0">
                            <h5 className="font-bold text-lg font-roboto">Amity Innovation Incubator</h5>
                            <p className="text-[#000000] text-sm sm:text-xs font-lato">
                                All products displayed on are procured from verified and licensed pharmacies. All labs listed on the platform are accredited.
                            </p>
                        </div> */}
                    </div>
                    <div className="flex flex-col items-start md:flex-row md:items-center justify-start space-x-4">
                        <img
                            src={require('../../src/assets/images/ISO.webp')}
                            alt="FSSAI"
                            className="w-20 h-auto"
                        />
                        <div className="text-left mt-2 md:mt-0">
                            <h5 className="font-bold text-lg font-roboto">ISO</h5>
                            <p className="text-[#000000] text-sm sm:text-xs font-lato">
                                Nutrivison Wellness and Genetics Pvt. Ltd is ISO-certified, internationally recognized standards for quality management and operational excellence, ensuring the highest level of safety in its processes.                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col items-start md:flex-row md:items-center justify-start space-x-4">
                        <img
                            src={require('../../src/assets/images/image-2.png')}
                            alt="MSME"
                            className="w-24 h-auto"
                        />
                        <div className="text-left mt-2 md:mt-0">
                            <h5 className="font-bold text-lg font-roboto">MSME</h5>
                            <p className="text-[#000000] text-sm sm:text-xs font-lato">
                                We hold a licence for Micro, Small, and Medium Enterprises (MSMEs), enabling us to contribute to the growth and development of the business ecosystem.                        </p>
                        </div>
                    </div>
                </div>

                <hr className="border-gray-300" />
                <div className="bg-gray-100 text-center py-4">
                    <p className="text-[#2B343B] text-lg sm:text-sm font-lato">
                        India’s only LegitScript and ISO/IEC 27001:2022 certified online healthcare platform
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer;
